import { render, staticRenderFns } from "./ttshop_accountaq.vue?vue&type=template&id=b6d7c6c8&scoped=true&"
import script from "./ttshop_accountaq.vue?vue&type=script&lang=js&"
export * from "./ttshop_accountaq.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_accountaq.vue?vue&type=style&index=0&id=b6d7c6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d7c6c8",
  null
  
)

export default component.exports